export default {
  detectionDetail: {
    title: "历史监测详情",
    component: () =>
      import("@/mods/warehouse/humitureManage/detailView/DetectionDetail"),
  },
};
